'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/button/style/css.js
// module id = ./node_modules/antd/lib/button/style/css.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons